const Overview = ({data, onEnquire}) => {
  return (
    <section id="overview" className="w-full bg-white px-4 sm:px-8 lg:px-10 py-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        
        {/* IMAGE — appears FIRST on small & medium */}
        <div className="relative w-full order-1 lg:order-2">
          <div className="relative z-10 rounded-lg overflow-hidden shadow-lg">
            <img
              src="/Images/BANNER/4.png"
              alt="Luxury apartments in Kharghar"
              className="w-full h-[220px] sm:h-[280px] md:h-[340px] lg:h-[360px] object-cover"
            />
          </div>

          {/* Decorative Border */}
          <div className="absolute hidden lg:block -right-4 -bottom-4 w-full h-full border-2 border-gray-300 rounded-lg"></div>
        </div>

        {/* CONTENT — appears BELOW image on small & medium */}
        <div className="order-2 lg:order-1">
          <h2 className="text-2xl md:text-3xl font-semibold text-[#090C6A] mb-4">
            About Rainbow Life
          </h2>

          <p className="text-gray-700 leading-relaxed text-sm md:text-base text-justify">
            {data.overview}
          </p>

          <button className="mt-6 flex items-center gap-2 bg-[#090c6a] hover:bg-[#1218A6] transition text-white px-6 py-3 rounded-xl text-sm font-medium shadow-md" onClick={onEnquire}>
            <span>↓</span>
            Request Brochure
          </button>
        </div>

      </div>
    </section>
  );
};

export default Overview;